import React from 'react'
import { useAuth } from '../../context/auth'
import { Link, useNavigate } from 'react-router-dom'
import { Navbar, Nav, Container } from 'react-bootstrap'
import '../../../src/styles/custom.css'

const MainHeader = () => {
  const [auth, setAuth] = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    setAuth({
      ...auth,
      user: null,
      token: '',
    })
    localStorage.removeItem('auth')
    navigate('/login', { state: { loggedOut: true } })
  }

  return (
    <Navbar
      collapseOnSelect
      expand='lg'
      variant='dark'
      fixed='top'
      className='custom-navbar'
      style={{ backgroundColor: '#556B2F' }}
    >
      <Container fluid>
        <div className='d-flex align-items-center w-100'>
          {auth?.user && (
            <Link
              className='navbar-brand me-auto'
              style={{ color: 'white', textDecoration: 'none' }}
              to={'/main/dashboard'}
            >
              <i className='bi bi-house-fill'></i>
            </Link>
          )}
          <Navbar.Toggle
            aria-controls='responsive-navbar-nav'
            className='ms-auto'
          />
        </div>
        <Navbar.Collapse id='responsive-navbar-nav'>
          <Nav className='me-auto'></Nav>
          <Nav style={{ minWidth: '100px', color: '#fff' }}>
            {auth?.user?.name}
          </Nav>

          <Nav>
            {auth?.user ? (
              <Nav.Link onClick={handleLogout}>
                <i className='bi bi-box-arrow-right'></i>
              </Nav.Link>
            ) : (
              <Nav.Link href='/login'>Login</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default MainHeader
